/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosInstance, AxiosResponse } from "axios";
import { GetModulesApiResponse } from "../../@types/DRO/GetModuleApiResponse";
import { erpAxios, getAuthToken } from "../axiosInstances";

export class GetModulesApi {
  public static api = new GetModulesApi();
  private instance = erpAxios;

  getToken() {
    return getAuthToken();
  }

  async getModule(): Promise<GetModulesApiResponse> {
    try {
        const response: AxiosResponse<GetModulesApiResponse> = await this.instance.get("/erp/api/v1/user/module", {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching predictions latest data", error);
        throw error;
    }
}

}
